export default __webpack_public_path__ + "76e684bfcc47f39b2567e9a9215b468f.png";